import { useEffect, useRef, useState } from 'react';
import { Mention, MentionsInput } from 'react-mentions';
import Utils from '@/common/utils/utils';
import Constant from '@/common/constant/Constant';
import { onSubmitCreateMsg, isPushDelegatePostMsg, createTmpUploadedFiles } from '../handler/ChatPostHandler';
import { isAIAssistantThread } from '../handler/ChatThreadHandler';
import { cloneDeep } from 'lodash';
import { IconButton, Menu, MenuItem, Tooltip, TextField, Dialog, CircularProgress } from '@material-ui/core';
import moment from 'moment';
import DateTimePickerInput from '@/component/common/form/datetime-picker/DateTimePickerInput';
import defaultMentionStyle from './defaultMentionStyle';
import './ChatInput.css';
import classNames from './CustomStyle.module.css'
import OverFlowTooltip from '@/component/common/OverFlowTooltip';
import ConfirmDialog from '@/common/dialog/ConfirmDialog';
import { checkDetailTicket } from '@/service/ticketService';
import { useRecoilValue } from 'recoil';
import { isEditedMsgInprogressAtom } from '@/state/atom/panelAtom';
import { handlerChangeTabThreadChat, scrollToActiveTab } from '../handler/ChatThreadHandler';
import { DialogConfirmCreateTicketError } from '@/component/ticketList/addTicketDialog/DialogConfirmCreateTicketError';
import { isQaAnonymousFromIframeOrChatBotApprovedAndCusInviteSettingOff } from '@/component/ticketList/handler/DetailTicketListHandler';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import { CkeditorConfiguration } from '@/common/constant/CkEditorConfiguration';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { getLinkDownloadFileFromS3 } from '@/component/common/FileUploaded';
import { uploadFileToS3InTMPFolder } from '@/common/utils/UploadFileUtil'; 
import SpecialCharactersEmoji from '@/component/formManagement/fieldUI/SpecialCharactersEmoji';
import { Storage } from 'aws-amplify';
import Checkbox from '@material-ui/core/Checkbox';
import { useDropzone } from 'react-dropzone';
import CloseIcon from '@material-ui/icons/Close';
import FileIcon from '@material-ui/icons/InsertDriveFile';
import { useSnackbar } from 'notistack';
import { v4 as uuidv4 } from 'uuid';
import { updatePublicAPI } from '@/service/publicService';
import { PropTypes } from 'prop-types';
import TelephoneConstant from '@/common/constant/TelephoneConstant';
import trI18n from '@/common/utils/trI18n';
import { tr } from '@/common/utils/tr';
import { useTranslationSubscription } from '@/hooks/useTranslation';
import { buildSnackbarMessage } from '@/component/common/SnackbarMessage';
const path = require('path');

// Keep the input position stable when the content grows: the group-send block stays fixed and the input expands upward.
// Must be inline style: classNames (CSS module) strips the react-mentions class names, so CSS selectors cannot match.
// The textarea (min-height 57px) overshoots the 50px control by a fixed amount; keep that overshoot constant
// so the visible input bottom edge does not move, and cap the highlighter so the control stops growing.
const chatInputMentionStyle = {
    ...defaultMentionStyle,
    '&multiLine': {
        ...defaultMentionStyle['&multiLine'],
        display: 'block',
        highlighter: {
            ...defaultMentionStyle['&multiLine'].highlighter,
            maxHeight: Constant.CHAT_INPUT_MAX_HEIGHT - Constant.CHAT_INPUT_TEXTAREA_OVERSHOOT
        },
        input: {
            ...defaultMentionStyle['&multiLine'].input,
            height: `calc(100% + ${Constant.CHAT_INPUT_TEXTAREA_OVERSHOOT}px)`
        }
    }
};

const ChatInput = props => {
    // Re-render when the translation dictionary loads/extends so tr() text updates.
    useTranslationSubscription();

    const {
        API,
        panelId,
        corporationId,
        ticketInfo,
        chatThreadId,
        corporationDetail,
        projectInuseDetail,
        userDetail,
        userDelegateCreateTicketDetail,
        isCheckDelegatePostMsg,
        isPostCreatedAtCurrentTime,
        postCreatedAtDateTime,
        setIsCreateNewMsg,
        setChatPostAllList,
        messageError,
        setMessageError,
        setChatPostInsertFail,
        setChatPostUpdate,
        selectedProjectId,
        userListCanMention,
        userChatList,
        setUserChatList,
        selectThread,
        setIsModalUploadFileError,
        setFileUploading,
        fileUploadedList,
        setFileUploadedList,
        threadChatList,
        setChangeToThread,
        setIsOpenConfirmChangeThread,
        setListChatInputValues,
        listChatInputValues,
        chatPostAllList,
        notShowMention,
        isDeliver,
        setIsLoading,
        reloadTicketDetail,
        setLastedSendMsgIdState,
        setIsDeliver,
        formDetail,
        ticketOriginInfor,
        formTargetDetail,
        escalationThread,
        isEnableChat,
        isDisableUserListDelegateMsg,
        onChangeSettingForm,
        onChangeSettingCurrentTime,
        onChangeSelectedGuestUser,
        handlePostCreatedAtDateTimeOnChange,
        isSentMessage,
        setIsSentMessage,
        customerReferenceThread,
        isDisableLink,
        isDisableUnsentCheckBox,
        uploadFiles,
        setUploadFiles,
        setUploadedFiles,
        setIsRendering,
        setIdMessageRendering,
        isChatThreadOnAiAssistant
    } = props;

    const isArchive = ticketInfo.liveOrArchived === Constant.LIVE_OR_ARCHIVED.ARCHIVED;
    const isDeleted = !Utils.isEmptyString(ticketInfo.deletedAt);
    const isEditedMsgInprogress = useRecoilValue(isEditedMsgInprogressAtom);
    const txtChatPostRef = useRef();
    const [isDisableBtnSend, setIsDisableBtnSend] = useState(true);
    let [listRenderMention, setListRenderMention] = useState([]);
    const [anchorEl, setAnchorEl] = useState(null);
    const [isOpenPopupTicketMsg, setIsOpenPopupTicketMsg] = useState(false);
    const [enterCount, setEnterCount] = useState(0);
    const [createMsgErr, setCreateMsgErr] = useState({ isShow: false, msg: '' })
    const [ckEditorState, setCKEditorState] = useState(Utils.isValidJSONString('') ? JSON.parse('') : '');
    const [selftCKEditor5, setSelftCKEditor5] = useState(null);
    const ckEditorId = Utils.generateRandomStr();

    let statusFirstShow = Constant.SEND_AND_CHANGE_STATUS_TYPE.PENDING;
    const ticketStatusValue = Utils.convertJSONDataToObject(ticketInfo.status);
    if (ticketStatusValue.value === Constant.STATUS_NO.DONE) {
        statusFirstShow = Constant.SEND_AND_CHANGE_STATUS_TYPE.DONE;
    }
    const [selected, setSelected] = useState(statusFirstShow);
    const [anchorOption, setAnchorOption] = useState(null);
    const openOption = Boolean(anchorOption);
    const options = [Constant.SEND_AND_CHANGE_STATUS_TYPE.TODO, Constant.SEND_AND_CHANGE_STATUS_TYPE.DOING, Constant.SEND_AND_CHANGE_STATUS_TYPE.PENDING, Constant.SEND_AND_CHANGE_STATUS_TYPE.DONE];
    const [isSendDone, setIsSendDone] = useState(false);

    const [openPreviewImage, setOpenPreviewImage] = useState(null);
    const { enqueueSnackbar } = useSnackbar();
    const [loadingInput, setLoadingInput] = useState(false);
    const [isUploading, setIsUploading] = useState(false);
    const dateTimePickerInputRef = useRef(null);

    // Convert datetime string to moment object for picker
    const getDateTimeValue = () => {
        if (Utils.isEmptyString(postCreatedAtDateTime)) {
            return null;
        }
        return moment(postCreatedAtDateTime, 'YYYY/MM/DD HH:mm', true);
    };

    const handleCloseDatePicker = () => {
        handlePostCreatedAtDateTimeOnChange(null);
    };

    // add scroll to input when maxHeight inputWrap = 440px 
    const chatInputWrapElement = document.querySelector('.formChat-wrap');
    const textareaElement = document.querySelector('.chat-input-qa-wrap textarea');
     
    if (chatInputWrapElement && textareaElement) {
        const style = window.getComputedStyle(textareaElement);

        const borderTop = parseInt(style.borderTopWidth, 10);
        const borderBottom = parseInt(style.borderBottomWidth, 10);
        const paddingTop = parseInt(style.paddingTop, 10);
        const paddingBottom = parseInt(style.paddingBottom, 10);
        const textareaHeight = Number(textareaElement.clientHeight);

        const maxHeightChatInputWrap = borderTop + borderBottom + paddingTop + paddingBottom + textareaHeight;
        if (Number(chatInputWrapElement.clientHeight) >= maxHeightChatInputWrap) {
                textareaElement.style.overflowY = 'hidden';
        }
        if (Number(chatInputWrapElement.clientHeight) < maxHeightChatInputWrap) {
            textareaElement.style.overflowY = 'auto';
        }
    }

    const indexChatInputValue = Utils.findIndexInArrayById(selectThread?.id, listChatInputValues);
    let infoChatInputValue = listChatInputValues[indexChatInputValue];
    let chatPostValue = infoChatInputValue?.content;

    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    const onClickSelectedThread = async (thread, isScroll = false, nextIndex = 0, tabLists = []) => {
        if(thread.id === selectThread?.id) {
            setAnchorEl(null);
            return;
        };
        setChangeToThread(thread);
        if(isEditedMsgInprogress) {
            setIsOpenConfirmChangeThread(true);
        } else {
            if (isScroll) setAnchorEl(null);
            await handlerChangeTabThreadChat(thread, props, projectInuseDetail.id);
            
            if (isScroll) {
                scrollToActiveTab(nextIndex, tabLists, selectThread?.id);
            }
        }
        setAnchorEl(null)
    };

    const onChangePost = e => {
        const updatedItem = {
            ...infoChatInputValue,
            content: e.target.value,
        }
        setListChatInputValues(listChatInputValues.map((item) => {
            return item.id === selectThread.id ? updatedItem: item;
        }))
    };

    useEffect(() => {
        let chatPost = ""

        if (!Utils.isEmptyString(chatPostValue)) {
            chatPost = chatPostValue?.trim();
        }

        if ((chatPost?.length < 1 && !uploadFiles.length) || isUploading) {
            setIsDisableBtnSend(true)  // Disabling the button if length is < 1
        } else {
            setIsDisableBtnSend(false)
        }
    },[chatPostValue, uploadFiles, isUploading])

    useEffect(() => {
        try {
            if (isDisableInputChat()) {
                if (selftCKEditor5 && selftCKEditor5.isReadOnly == false) {
                    selftCKEditor5.enableReadOnlyMode(selftCKEditor5.id);
                }
            } else {
                if (selftCKEditor5 && selftCKEditor5.isReadOnly == true) {
                    selftCKEditor5.disableReadOnlyMode(selftCKEditor5.id);
                }
            }
        } catch (error) {
            console.log('err 1:>> ', error);
        }
    });

    const onAddMention = (id, display, startPos, endPos) => {
    };

    const handleKeyDown = async (e) => {
        const keyCode = e.which || e.keyCode;
        
        // 13 represents the Enter key
        if (keyCode === 13 && !e.shiftKey) {
            e.target.blur();
            // Don't generate a new line
            e.preventDefault();
            setEnterCount(count => count + 1);
            // Do something else such as send the message to back-end
            if (
                ((Utils.isEmptyString(chatPostValue) || chatPostValue.trim() === '') &&
                    Utils.isEmptyArray(uploadFiles)) ||
                (enterCount >= 1 && !Utils.isEmptyString(messageError))
            ) {
                return;
            }

            if(enterCount === 0) await onSendChatPost(true);

        } else {
            setEnterCount(0); // reset enterCount nếu không phải phím Enter
        }
    }

    const refactorChatPostContent = async chatPostContent => {
        const urls = Utils.getRichTextUrls(null, chatPostContent);
        const s3Keys = Utils.getKeyFileFromCDNLinks(urls) || [];
        let newUrls = [];
        const putFilesProcess = [];
        for (const s3Key of s3Keys) {
            const file = await Storage.get(s3Key?.keyFile.replace('/public/', ''), {
                download: true,
                cacheControl: 'no-cache'
            });
            const fileName = path.basename(s3Key?.keyFile.replace('/public/', ''));
            const currentTime = new Date();
            const s3ChatPostFilePath = `${corporationId}/ticket/${
                selectThread.ticketId
            }/chatThread/${chatThreadId}/${userDetail?.id}/${currentTime.getTime()}/${fileName}`;
            putFilesProcess.push(
                Storage.put(s3ChatPostFilePath, file?.Body, {
                    level: 'public',
                    contentType: file?.ContentType
                })
            );
        }
        const s3PutFilesResult = await Promise.all(putFilesProcess);
        for (const s3PutFileResult of s3PutFilesResult) {
            const data = {
                id: Math.random(),
                fileUrl: s3PutFileResult?.key,
                chatThreadType: selectThread?.threadType,
                type: Constant.S3_FILE_TYPE.CHAT_POST_FILE,
                sharedRange: selectThread?.sharedRange
            };
            const newLink = getLinkDownloadFileFromS3(data, ticketInfo, null, null, false, false);
            newUrls.push(newLink);
        }
        let newChatPostContent = '';
        urls?.forEach((url, idx) => {
            newChatPostContent = newChatPostContent.replace(url, newUrls[idx] + `\\"`);
        });
        return chatPostContent;
    };

    const onSendChatPost = async (isSendByEnter) => {
        setLoadingInput(true);
        setIsDisableBtnSend(true);
        let ticketId = ticketInfo.id;
        let {status: currentStatusTicket} = await checkDetailTicket(API, ticketId);
        if (currentStatusTicket === Constant.TICKET_DELETED_STATUS.REMOVED) {
            setIsOpenPopupTicketMsg(true);
            setLoadingInput(false);
            return;
        }

        if(isAIAssistantThread(selectThread) && isChatThreadOnAiAssistant){
            setIsDisableBtnSend(true);
            setIsRendering(true)
        }

        let statusSend = '';

        if (isSendToCustomerBySdesk()) {
            statusSend = selected;

        } else if (isShowCheckboxSendDoneByCustomer(true)) {
            statusSend = getStatusSendByCustomer();
        }

        let messageParser = [...chatPostValue.matchAll(/@\[(.*?)]\((.*?)\)/g)];
        const GET_MENTION_ID_REGEX = /(user_[a-z0-9\-]+|ALL)(?=\))/g
        let mentionsList = chatPostValue.match(GET_MENTION_ID_REGEX);

        let messageForSave = chatPostValue;
        let messageForDisplay = chatPostValue;
        for (const part of messageParser) {
            messageForSave = messageForSave.replace(`${part[0]}`, `@[${part[2]}]`);
            messageForDisplay = 'messageForDisplay';
        }

        // apply when chat post content is ckeditor data. apply for email customer thread. we can be apply more and more for future. start
        const isEmailCustomerThread = isSelectedTicketTypeAndThreadType(
            Constant.TICKET_TYPE.EMAIL,
            Constant.THREAD_CHAT_TYPE.CUSTOMER_THREAD
        );
        if(isEmailCustomerThread){
            messageForSave = await refactorChatPostContent(messageForSave);
        }
        // apply when chat post content is ckeditor data. apply for email customer thread. we can be apply more and more for future. end
        let dataSubmit = {
            API: API,
            corporationId: corporationId,
            ticketInfo: ticketInfo,
            chatThreadId: chatThreadId,
            userDetail: userDetail,
            userDelegateCreateTicketDetail: userDelegateCreateTicketDetail,
            isDelegateThread: isCheckDelegatePostMsg,
            isPostCreatedAtCurrentTime: isPostCreatedAtCurrentTime,
            postCreatedAtDateTime: postCreatedAtDateTime,
            setIsCreateNewMsg: setIsCreateNewMsg,
            setChatPostAllList: setChatPostAllList,
            setMessageError: setMessageError,
            setChatPostInsertFail: setChatPostInsertFail,
            setChatPostUpdate: setChatPostUpdate,
            txtChatPostRef: txtChatPostRef,
            selectedProjectId: selectedProjectId,
            contentPost: messageForSave.trim(),
            mentionsList: mentionsList,
            messageForDisplay: messageForDisplay,
            selectThread: selectThread,
            corporationDetail,
            projectInuseDetail,
            isDeliver,
            setCreateMsgErr,
            setIsLoading,
            reloadTicketDetail,
            setLastedSendMsgIdState,
            setIsDeliver,
            statusSend,
            isSentMessage,
            uploadFiles,
            setUploadedFiles,
            setIdMessageRendering
        };

        const isSended = await onSubmitCreateMsg(dataSubmit);
        if (!isSended) {
            setIsDisableBtnSend(false);
            return
        }
        const updatedItem = {
            ...infoChatInputValue,
            content: '',
        }
        setListChatInputValues(listChatInputValues.map((item) => {
            return item.id === selectThread.id ? updatedItem: item;
        }))
        setCKEditorState('');
        setIsSendDone(false);
        setLoadingInput(false);
        setUploadFiles([]);
        setEnterCount(0);
    }

    useEffect(() => {
        let listRenderMentionClone = [];

        if (!Utils.isEmptyArray(userListCanMention)) {
            let userChatListClone = Utils.isEmptyArray(userChatList) ? [] : cloneDeep(userChatList);

            userListCanMention?.forEach(user => {
                let renderTemplate = {};
                renderTemplate[`id`] = user.id;
                renderTemplate[`display`] =
                    user.id !== Constant.CHAT_MENTION_ALL.id
                        ? `${Utils.getFullNameOfUser(Constant.LANGUAGE_TYPE.JP, user)} ${user.mail}`
                        : `${Constant.CHAT_MENTION_ALL.name} all`;
                renderTemplate[`mail`] = user.mail;
                renderTemplate[`avatar`] = user.avatar;

                listRenderMentionClone.push(renderTemplate);

                // update user to userChatList
                if (Utils.findIndexInArrayById(user.id, userChatListClone) === -1) {
                    userChatListClone.push(user);
                }
            });

            setListRenderMention(listRenderMentionClone);

            // push more user if not exist in userChatList
            setUserChatList(prev => {
                let mergedList = Utils.isEmptyArray(prev) ? [] : cloneDeep(prev);
                userChatListClone?.forEach(user => {
                    if (Utils.findIndexInArrayById(user.id, mergedList) === -1) {
                        mergedList.push(user);
                    }
                });

                return mergedList;
            });
        }
    }, [userListCanMention]);

    const validateFilesUpload = (filesUpload = []) => {
        if (filesUpload.length + uploadFiles.length > Constant.LIMIT_FILES_UPLOAD) {
            enqueueSnackbar(buildSnackbarMessage('INVALID_TOO_MANY_FILES'), {
                variant: 'error',
                autoHideDuration: 2000
            });
            return false;
        }
        if (filesUpload.some(item => item.size > 50 * 1024 * 1024)) {
            enqueueSnackbar(buildSnackbarMessage('INVALID_TOO_LARGE_FILE'), {
                variant: 'error',
                autoHideDuration: 2000
            });
            return false;
        }
        return true;
    };

    const handlePostImageFileOnChange = event => {
        const filesUpload = Array.from(event.target.files);
        if (!validateFilesUpload(filesUpload) || loadingInput) {
            return;
        }
        event.target.value = '';
        uploadTmpFile(filesUpload);
    };

    const handlePaste = event => {
        if (isAIAssistantThread(selectThread)) return;
        const clipboardItems = Array.from(event.clipboardData.items);
        const imageFiles = clipboardItems
            .filter(item => item.type.startsWith('image'))
            .map(item => item.getAsFile());
        if (!validateFilesUpload(imageFiles) || loadingInput) {
            return;
        }
        uploadTmpFile(imageFiles)
    };

    const onDrop = newFiles => {
        if (!validateFilesUpload(newFiles) || loadingInput) {
            return;
        }
        uploadTmpFile(newFiles)
    };

    const uploadTmpFile = newFiles => {
        const files = newFiles.map(file => ({
            id: `tmp_attach_${uuidv4()}`,
            localUrl: URL.createObjectURL(file),
            fileData: file
        }));
        setUploadFiles(prev => [...prev, ...files]);
        createTmpUploadedFiles({
            corporationId: corporationDetail.id,
            projectInuseId: projectInuseDetail.id,
            chatThreadId,
            files,
            setUploadFiles,
            setIsUploading
        });
    };

    const handleSuggestion = (e) => {
        let lastIndex = e.display.lastIndexOf(' ');
        let textDisplay = e.display.substr(0, lastIndex);
        return (
            <div className="suggestion-wrapper">
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <div style={{ flex: ' 0 0 20px' }}>
                        <img
                            src={e.avatar}
                            alt=""
                            width={'20px'}
                            style={{ borderRadius: '50%', height: '20px' }}
                        />
                    </div>
                    <div>
                        <OverFlowTooltip value={textDisplay} className="suggestion-name"/>
                        <OverFlowTooltip value={e.mail} className="suggestion-mail"/>
                    </div>
                </div>
            </div>
        );
    };

    const displayTransform = (id, display) => {
        let lastIndex = display.lastIndexOf(' ');
        let textDisplay = display.substr(0, lastIndex);
        return `@${textDisplay}`;
    };

    const handleReload = () => {
        window.location.reload();
    }


    const isCustomerChatThread = () => {
        return selectThread?.threadType === Constant.THREAD_CHAT_TYPE.CUSTOMER_THREAD;
    }

    const handleClickOption = (event) => {
        setAnchorOption(event.currentTarget);
    };
    
    const handleCloseOption = (option) => {
        if (option) setSelected(option);
        setAnchorOption(null);
    };

    const handleSendAndChangeStatus = (e) => {
        onSendChatPost()
    }

    const handleChangeSendDoneByCustomer = (e) => {
        let newValue = e.target.checked;
        setIsSendDone(newValue ? true : false); 
    }

    const isDisplayUploadFileIcon = () => {
        if (isAIAssistantThread(selectThread)) return false;
        if (
            [Constant.TICKET_TYPE.EMAIL,Constant.TICKET_TYPE.EMAIL_REPLY].includes(ticketInfo.ticketType) &&
            selectThread?.threadType === Constant.THREAD_CHAT_TYPE.CUSTOMER_THREAD
        ) {
            return false
        }
        return true
    }

    const isDisableInputChat = () => {
        if (isArchive || isDeleted) return true;

        if ([Constant.TICKET_TYPE.EMAIL, Constant.TICKET_TYPE.EMAIL_REPLY].includes(ticketInfo.ticketType)) {
            const ticketStatus = Utils.convertJSONDataToObject(ticketInfo.status);
            return (
                ticketStatus.value === Constant.STATUS_NO.DONE &&
                (
                    !Utils.isPublicDesk(projectInuseDetail) ||
                    !Utils.isEnableCreateEmailTicketModeOnSkipProjectType(corporationDetail, projectInuseDetail)
                )
            )
        } else if ([Constant.TICKET_TYPE.BROADCAST_CHILD,Constant.TICKET_TYPE.BROADCAST_PARENT].includes(ticketInfo.ticketType)) {
            const isNoticeInternalProject = props.ticketListType === Constant.TYPE_GET_TICKET_LIST.CUSTOMER
            return isNoticeInternalProject
        } else {
            return isQaAnonymousFromIframeOrChatBotApprovedAndCusInviteSettingOff(projectInuseDetail, ticketInfo) && isCustomerChatThread()
        }
    }
    const isHelpDeskPanelChat = props?.panelType === Constant.PANEL_TYPE.HELPDESK_CHATTHREAD;
    const isCustomerPanelChat = props?.panelType === Constant.PANEL_TYPE.CUSTOMER_CHATTHREAD;
    const isEscalateChatThread = selectThread?.threadType === Constant.THREAD_CHAT_TYPE.ESCALATION_THREAD;
    const isQATicket = [
        Constant.TICKET_TYPE.QA,
        Constant.TICKET_TYPE.DELEGATE,
        Constant.TICKET_TYPE.ESCALATION,
        Constant.TICKET_TYPE.INTERNAL_QA,
        Constant.TICKET_TYPE.EXTERNAL_QA
    ].includes(ticketInfo?.ticketType);

    const isShowCheckboxSendDoneByCustomer = (isSendDoing = false) => {
        if (!isQATicket) return false;

        if (![Constant.THREAD_CHAT_TYPE.ESCALATION_THREAD, Constant.THREAD_CHAT_TYPE.CUSTOMER_THREAD].includes(selectThread?.threadType)) return false;

        if (selectThread?.ticketId === ticketOriginInfor?.id) {
            if (formTargetDetail?.definition === Constant.FORM_DEFINITION.SYSTEM) return false;

            if (!formTargetDetail?.isAllowCustomerChangeStatus && !isSendDoing) return false;

            const ticketTargetStatus = Utils.convertJSONDataToObject(ticketOriginInfor?.status); 
            let isStatusTicketWaitingOrDone = [Constant.STATUS_NO.WAITING, Constant.STATUS_NO.DONE].includes(ticketTargetStatus?.value);
            if (isStatusTicketWaitingOrDone) return false;

            const isTicketTargetArchive = ticketOriginInfor?.liveOrArchived === Constant.LIVE_OR_ARCHIVED.ARCHIVED;
            const isTicketTargetDeleted = !Utils.isEmptyString(ticketOriginInfor?.deletedAt);
            if (isTicketTargetArchive || isTicketTargetDeleted) return false;

            if (!isHelpDeskPanelChat) return true;

        } else {
            if (formDetail?.definition === Constant.FORM_DEFINITION.SYSTEM) return false;

            if (!formDetail?.isAllowCustomerChangeStatus && !isSendDoing) return false;

            const ticketStatus = Utils.convertJSONDataToObject(ticketInfo?.status); 
            let isStatusTicketWaitingOrDone = [Constant.STATUS_NO.WAITING, Constant.STATUS_NO.DONE].includes(ticketStatus?.value);
            if (isStatusTicketWaitingOrDone) return false;

            if (isArchive || isDeleted) return false;

            if (isCustomerChatThread() && isCustomerPanelChat && projectInuseDetail?.id !== ticketInfo?.affiliationProject) return true;

            if (isEscalateChatThread) return true;
        }

        return false;
    };

    const isSendToCustomerBySdesk = () => {
        if (!isQATicket) return false;
        if (![Constant.THREAD_CHAT_TYPE.ESCALATION_THREAD, Constant.THREAD_CHAT_TYPE.CUSTOMER_THREAD].includes(selectThread?.threadType)) return false;
        if (selectThread?.ticketId === ticketOriginInfor?.id) {
            return validateSendToCustomerBySdeskCommon(formTargetDetail, ticketOriginInfor);    
        } else {
            return validateSendToCustomerBySdeskCommon(formDetail, ticketInfo);    
        }   
    };

    const validateSendToCustomerBySdeskCommon = (formData, ticketData) => {
        if (Utils.isEmptyString(ticketData?.personInCharge)) return false;
        if (formData?.definition === Constant.FORM_DEFINITION.SYSTEM) return false;
        
        if (
            isHelpDeskPanelChat &&
            isEscalateChatThread &&
            projectInuseDetail?.id === ticketData?.affiliationProject
        ) {
            return true;
        }

        if (!isCustomerChatThread()) return false;

        if (isHelpDeskPanelChat) {
            return true;
        }

        if (isCustomerPanelChat && projectInuseDetail?.id === ticketData?.affiliationProject) {
            return true;
        }
        return false;
    }

    const getStatusSendByCustomer = () => {
        let ticketSendChat = ticketInfo;
        if (selectThread?.ticketId === ticketOriginInfor?.id) {
            ticketSendChat = ticketOriginInfor;
        }
        const ticketStatus = Utils.convertJSONDataToObject(ticketSendChat?.status); 
        let statusTicket = ticketStatus?.value;

        if ([Constant.STATUS_NO.WAITING, Constant.STATUS_NO.DONE].includes(statusTicket)) return '';
        if (isSendDone) return Constant.SEND_AND_CHANGE_STATUS_TYPE.DONE;
        if (statusTicket === Constant.STATUS_NO.TODO)
            return Constant.SEND_AND_CHANGE_STATUS_TYPE.TODO;

        return Constant.SEND_AND_CHANGE_STATUS_TYPE.DOING;
    };

    const handleOnChangeCKEditor = (event, editor) => {
        try {
            const htmlContent = editor.getData();
            setCKEditorState(htmlContent);
            const updatedItem = {
                ...infoChatInputValue,
                content: htmlContent
            }
            setListChatInputValues(listChatInputValues.map((item) => {
                return item.id === selectThread.id ? updatedItem: item;
            }))
        } catch (error) {
            console.log('handleOnChangeCKEditor', error)
        }
    }

    /**
     * Custom image upload to S3 storage.
     * 
     * Ref: https://ckeditor.com/docs/ckeditor5/latest/framework/deep-dive/upload-adapter.html
     */
    function uploadImageAdapterPlugin(editor) {
        try {
            editor.plugins.get('FileRepository').createUploadAdapter = (loader) => {
                return handleUploadImageAdapter(loader);
            };
        } catch (error) {
            console.log('uploadImageAdapterPlugin', error)
        }
        
    }

    const handleUploadImageAdapter = (loader) => {
        return {
            upload: async () => {
                return loader.file.then((file)=>{
                    //setIsLoadingUploadFile(true)
                    return file
                }).then(async (file) => {
                    const result = await uploadFileToS3InTMPFolder(file);
                    let fileUpload = {
                        id: Math.random(),
                        fileUrl: result.key,
                        type: Constant.S3_FILE_TYPE.CHAT_POST_FILE,
                        sharedRange: selectThread?.sharedRange
                    };
                    let link = await getLinkDownloadFileFromS3(fileUpload, selectThread, null, null, false, true);
                    return {
                        default: `${link}`
                    };
                }).finally( ()=>{
                    //setTimeout(()=> setIsLoadingUploadFile(false), 600)
                });
            }
        };
    }

    const { getRootProps, getInputProps, inputRef } = useDropzone({
        onDrop,
        disabled: isDisableInputChat() || isAIAssistantThread(selectThread)
    });

    const deleteFile = file => {
        if (loadingInput) {
            return;
        }
        if (inputRef.current) {
            inputRef.current.value = '';
        }
        setUploadFiles(uploadFiles.filter(i => i !== file));
        file.localUrl && URL.revokeObjectURL(file.localUrl);
        updatePublicAPI(null, {
            updateApiType: Constant.UPDATE_API_PUBLIC_TYPE.DELETE_S3_FILE_BY_PATH,
            s3Path: file.s3Path
        });
    };

    const renderInputChat = () => {
        const isEmailCustomerThread = isSelectedTicketTypeAndThreadType(
            Constant.TICKET_TYPE.EMAIL,
            Constant.THREAD_CHAT_TYPE.CUSTOMER_THREAD
        );

        if (!isEmailCustomerThread)
            return (
                <>
                    <div
                        onPaste={handlePaste}
                        {...getRootProps()}
                        className={`single-line chat-input-qa-wrap ${
                            isDisableInputChat() ? 'disable-textarea' : ''
                        }`}
                    >
                        <MentionsInput
                            {...getInputProps()}
                            forceSuggestionsAboveCursor={true}
                            // singleLine={true}
                            value={chatPostValue}
                            rows={1}
                            onChange={onChangePost}
                            placeholder={trI18n('PLACE-HOLDER')}
                            className="mentionWrapper"
                            classNames={classNames}
                            style={chatInputMentionStyle}
                            spellCheck="false"
                            disabled={isDisableInputChat()}
                            onKeyDown={e => handleKeyDown(e)}
                        >
                            <Mention
                                className={classNames.mentions__mention}
                                style={{
                                    fontSize: '15px',
                                    lineHeight: 1.8
                                }} /* hot fix mention input */
                                trigger={/(?:^|\s)(@([^\s]*))$/}
                                // trigger="@"
                                displayTransform={displayTransform}
                                markup="@[__display__](__id__)"
                                data={notShowMention ? [] : listRenderMention}
                                onAdd={onAddMention}
                                renderSuggestion={handleSuggestion}
                                appendSpaceOnAdd={true}
                            />
                        </MentionsInput>
                    </div>
                </>
            );

        return (
            <>
                <div
                    id={`ckbox-${ckEditorId}`}
                    data-cy="richtext-editor"
                    className={`
                        editor input-chat
                        ${
                            isDisableInputChat()
                                ? 'sdesk-editor editor-view ckeditor5-readonly '
                                : 'sdesk-editor'
                        }
                    `}
                >
                    <CKEditor
                        editor={window.CKEDITOR.ClassicEditor}
                        data={ckEditorState}
                        config={{
                            ...CkeditorConfiguration,
                            placeholder: trI18n('PLACE-HOLDER'),
                            extraPlugins: [
                                SpecialCharactersEmoji,
                                uploadImageAdapterPlugin
                            ],
                        }}
                        onReady={editor => {
                            setSelftCKEditor5(editor);
                            editor.ui.view.toolbar.element.style.display = 'none';
                            if (isDisableInputChat()) {
                                editor.enableReadOnlyMode(editor.id);
                            }
                            editor.model.document.on('change', (event, editorData) => {
                                if (isDisableInputChat()) return;
                                handleOnChangeCKEditor(event, editor);
                            });
                        }}
                        onFocus={(event, editor) => {
                            window.editor = editor;
                            document
                                .querySelectorAll(
                                    `.editor .ck.ck-sticky-panel__content > .ck.ck-toolbar[aria-label="Editor toolbar"]`
                                )
                                .forEach(el => {
                                    el.style.display = 'none';
                                });
                            editor.ui.view.toolbar.element.style.display = 'block';
                        }}
                    />
                </div>
            </>
        );
    };

    const isSelectedTicketTypeAndThreadType = (ticketType, threadType) => {
        if (ticketInfo?.ticketType === ticketType && selectThread?.threadType === threadType) {
            return true;
        }
        return false;
    };

    const renderUnsentCheckBox = () => {
        const isHiddenUnsentCheckBox = () => {
            // Handle TELEPHONE PROJECT_TO_PROJECT separately
            if (ticketInfo?.ticketType === Constant.TICKET_TYPE.TELEPHONE &&
                Utils.defineVoiceCallFlow(ticketInfo?.metaData) === TelephoneConstant.VOICE_CALL_FLOW.PROJECT_TO_PROJECT
            ) {
                const ticketMetaData = Utils.convertJSONDataToObject(ticketInfo?.metaData);
                const { from, to } = ticketMetaData;
                // Neither the calling nor receiving project — hide checkbox
                if (selectedProjectId !== from && selectedProjectId !== to) return true;
            }

            if (!Constant.TICKET_TYPES_WITH_UNSENT_TOGGLE.includes(ticketInfo.ticketType)) {
                return true;
            }
            
            if ({...customerReferenceThread}.id === {...selectThread}.id) {
                return true;
            }

            if (ticketInfo.affiliationProject !== selectedProjectId) {
                return true;
            }

            if (
                { ...selectThread }.threadType !== Constant.THREAD_TYPE.CUSTOMER &&
                { ...selectThread }.threadType !== Constant.THREAD_TYPE.ESCALATION
            ) {
                return true;
            }

            if (
                { ...selectThread }.ticketId !== ticketInfo.id &&
                { ...selectThread }.threadType === Constant.THREAD_TYPE.ESCALATION
            ) {
                return true;
            }

            return false;
        };

        const isNotShowUnsentCheckBox = isHiddenUnsentCheckBox();
        if (isNotShowUnsentCheckBox) return <></>;

        return (
            <div className='unsend-checkbox'> 
                <div className={`email-deliver ${(isDisableLink || isDisableUnsentCheckBox) ? 'deliver-disable': 'checkbox-deliver'}`}>
                    <Checkbox
                        checked={isSentMessage}
                        onClick={() => {
                            setIsSentMessage(!isSentMessage);
                        }}
                        color ="secondary"
                        disabled={isDisableLink || isDisableUnsentCheckBox}
                        className={(isDisableLink || isDisableUnsentCheckBox) ? 'checkbox-deliver-disable': 'checkbox-deliver-enbale' }
                    />
                    <span className="cursor-auto">{trI18n('MESSAGE_SENT')}</span>
                </div>
            </div>
        );
    };    

    return (
        <>
            {!Utils.isEmptyArray(uploadFiles) && (
                <div className="container-files-input">
                    {uploadFiles.map((file, index) => {
                        if (Utils.isImageFile(file.fileData.name)) {
                            return (
                                <div className="container-image-item" key={file.id}>
                                    <img
                                        src={file.localUrl}
                                        alt={`upload-${index}`}
                                        onClick={() => setOpenPreviewImage(file.localUrl)}
                                        style={{
                                            borderRadius: 6,
                                            width: '100%',
                                            height: '100%',
                                            objectFit: 'cover'
                                        }}
                                    />
                                    {!file.s3Path ? (
                                        <CircularProgress
                                            size={14}
                                            style={{
                                                position: 'absolute',
                                                inset: 0,
                                                margin: 'auto',
                                            }}
                                        />
                                    ) : (
                                        <div
                                            className="file-remove-btn"
                                            onClick={() => deleteFile(file)}
                                        >
                                            <CloseIcon style={{ width: 14, height: 14 }} />
                                        </div>
                                    )}
                                </div>
                            );
                        } else {
                            return (
                                <Tooltip
                                    title={file.fileData.name}
                                    placement="top"
                                    arrow
                                    key={file.id}
                                >
                                    <div className="container-file-item">
                                        <FileIcon
                                            style={{ width: 40, height: 40, color: '#2d72d2' }}
                                        />
                                        <div className="container-file-name-item">
                                            <span>{file.fileData.name}</span>
                                            <span>
                                                {file.fileData.name
                                                    .split('.')
                                                    .pop()
                                                    .toLowerCase()}
                                            </span>
                                        </div>
                                        {!file.s3Path ? (
                                            <CircularProgress
                                                size={14}
                                                style={{
                                                    position: 'absolute',
                                                    inset: 0,
                                                    margin: 'auto'
                                                }}
                                            />
                                        ) : (
                                            <div
                                                className="file-remove-btn"
                                                onClick={() => deleteFile(file)}
                                            >
                                                <CloseIcon style={{ width: 14, height: 14 }} />
                                            </div>
                                        )}
                                    </div>
                                </Tooltip>
                            );
                        }
                    })}
                </div>
            )}
            <div className={`group-fild ${isSendToCustomerBySdesk() ? 'w-100' : ''}`}>
                {!Utils.isEmptyArray(threadChatList) &&
                    threadChatList.length > 1 &&
                    props.isShowAllChatPost && (
                        <div className="drop-down-list-chat">
                            <div className="name-selected">{tr('送信先:')}</div>
                            <div className="chat-selected" onClick={handleClick}>
                                <span
                                    className="name-selected"
                                    style={{ color: `${selectThread.colorTabThread}` }}
                                >
                                    {selectThread?.projectName}
                                </span>
                                <img
                                    src="/assets/image/chevron-down.svg"
                                    alt=""
                                    className={`${anchorEl && 'rotate-chevron'} chevron-icon`}
                                />
                            </div>
                        </div>
                    )}
                <Menu
                    id="demo-positioned-menu"
                    aria-labelledby="demo-positioned-button"
                    anchorEl={anchorEl}
                    open={open}
                    onClose={handleClose}
                    anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'center'
                    }}
                    transformOrigin={{
                        vertical: 'bottom',
                        horizontal: 'center'
                    }}
                    getContentAnchorEl={null}
                    MenuListProps={{
                        className: 'menu-list-tab-thread'
                    }}
                >
                    {!Utils.isEmptyArray(threadChatList) &&
                        threadChatList.length > 1 &&
                        threadChatList?.map((item, index) => {
                            return (
                                <Tooltip title={item.label} arrow placement="top-center">
                                    <MenuItem
                                        onClick={() =>
                                            onClickSelectedThread(
                                                item.data,
                                                true,
                                                index,
                                                threadChatList
                                            )
                                        }
                                        selected={item.data?.id === selectThread?.id}
                                    >
                                        <span>{item.label}</span>
                                    </MenuItem>
                                </Tooltip>
                            );
                        })}
                </Menu>
                {/* // */}
                <div>{renderInputChat()}</div>
                <div className="group-fildBtn">
                    <div className="icon-tools">
                        <IconButton
                            className="itemTools"
                            disabled={isArchive}
                            style={{ display: 'none' }}
                        >
                            <img src="/assets/image/icon-color.svg" alt="" />
                        </IconButton>
                    </div>
                    <div className="icon-tools">
                        <IconButton
                            className="itemTools"
                            disabled={isDisableInputChat()}
                            style={{ display: 'none' }}
                        >
                            <img src="/assets/image/icon-smile.svg" alt="" />
                        </IconButton>
                    </div>
                    {isDisplayUploadFileIcon() && (
                        <div className="icon-tools">
                            <input
                                multiple
                                accept="*"
                                className="upload"
                                id={`icon-button-photo-${panelId}`}
                                type="file"
                                onChange={handlePostImageFileOnChange}
                                disabled={isDisableInputChat() || loadingInput}
                            />
                            <label htmlFor={`icon-button-photo-${panelId}`}>
                                <IconButton
                                    className="itemTools"
                                    aria-label="upload picture"
                                    component="span"
                                    disabled={isDisableInputChat()}
                                >
                                    <img src="/assets/image/icon-fileUpload.svg" alt="" />
                                </IconButton>
                            </label>
                        </div>
                    )}
                </div>
            </div>
            <div
                className={`groupBtn-send ${
                    isDisableBtnSend || isDisableInputChat() ? 'groupBtn-send-disable' : ''
                } ${isSendToCustomerBySdesk() ? 'displayNone' : ''}`}
            >
                <IconButton
                    className="btnSend"
                    onClick={() => {
                        if (isDisableBtnSend || isDisableInputChat()) return;
                        onSendChatPost();
                    }}
                    disabled={isDisableBtnSend || isDisableInputChat()}
                >
                    <img src="/assets/image/icon-send.svg" alt="" />
                </IconButton>
            </div>
            {isShowCheckboxSendDoneByCustomer() && (
                <div className="send-msg-by-customer">
                    <input
                        type="checkbox"
                        id={`checkbox-send-msg-by-customer`}
                        defaultChecked={isSendDone ? true : false}
                        checked={isSendDone ? true : false}
                        className="send-msg-by-customer-checkbox"
                        onClick={e => handleChangeSendDoneByCustomer(e)}
                        disabled={isDisableBtnSend || isDisableInputChat()}
                    />
                    <label
                        className={`label-search-pdf ${
                            isDisableBtnSend || isDisableInputChat() ? 'opacity-label' : ''
                        }`}
                        htmlFor={`checkbox-send-msg-by-customer`}
                    >
                        {trI18n('LABEL-CUSTOMER-TO-CHANGE_COMPLETE-STATUS')}
                    </label>
                </div>
            )}

            <div className={`group-send`}>
                {isSendToCustomerBySdesk() &&
                    isPushDelegatePostMsg(
                        isEnableChat,
                        selectThread,
                        props.panelType,
                        ticketInfo,
                        escalationThread
                    ) && (
                        <div>
                            {/* config post msg */}
                            <div className="chatSetting-head">
                                <div className="chatSetting-switch">
                                    <div className="title">{tr('代理投稿')}</div>
                                    <div className="chatSetting-form">
                                        <div className="switch-check">
                                            <input
                                                type="checkbox"
                                                id={`switch-${panelId}`}
                                                defaultChecked={isCheckDelegatePostMsg}
                                                onChange={onChangeSettingForm}
                                                disabled={
                                                    isArchive ||
                                                    !Utils.isEmptyString(ticketInfo.deletedAt)
                                                }
                                            />
                                            <label for={`switch-${panelId}`}></label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}

                {renderUnsentCheckBox()}

                {isSendToCustomerBySdesk() && (
                    <div className={`send-msg-by-sdesk`}>
                        <div
                            className={`send-msg-by-sdesk-box ${
                                isDisableBtnSend || isDisableInputChat() ? 'class_disabled' : ''
                            } ${isCheckDelegatePostMsg ? 'send-msg-by-sdesk-box-view-2' : ''}`}
                        >
                            <div
                                className="send-msg-by-sdesk-box-right"
                                onClick={handleSendAndChangeStatus}
                            >
                                <span className="send-and-change-status">{tr(selected)}</span>
                            </div>
                            <div className="send-msg-by-sdesk-box-left">
                                <div className="send-msg-by-sdesk-box-break"></div>
                                <IconButton
                                    onClick={handleClickOption}
                                    className="icon-option-change-status"
                                >
                                    <ExpandMoreIcon />
                                </IconButton>
                                <Menu
                                    anchorEl={anchorOption}
                                    open={openOption}
                                    onClose={() => handleCloseOption(null)}
                                    anchorOrigin={{
                                        vertical: 'top',
                                        horizontal: 'right'
                                    }}
                                    transformOrigin={{
                                        vertical: 'bottom',
                                        horizontal: 'right'
                                    }}
                                >
                                    {options.map(option => (
                                        <MenuItem
                                            key={option}
                                            onClick={() => handleCloseOption(option)}
                                        >
                                            {tr(option)}
                                        </MenuItem>
                                    ))}
                                </Menu>
                            </div>
                        </div>
                    </div>
                )}
            </div>

            {isCheckDelegatePostMsg &&
                isSendToCustomerBySdesk() &&
                isPushDelegatePostMsg(
                    isEnableChat,
                    selectThread,
                    props.panelType,
                    ticketInfo,
                    escalationThread
                ) && (
                    <div className="group-send">
                        {/* settingCurrentTime */}
                        <div className="chatSetting-switch">
                            <div className="title">{tr('現在時刻')}</div>
                            <div className="chatSetting-form">
                                <div className="switch-check">
                                    <input
                                        type="checkbox"
                                        id="currentTime"
                                        defaultChecked={isPostCreatedAtCurrentTime}
                                        onChange={onChangeSettingCurrentTime}
                                    />
                                    <label for="currentTime"></label>
                                </div>
                            </div>
                        </div>

                        {/* post msg */}
                        <div className="chatSetting-post">
                            <div className="chatSetting-content">
                                <div className="chatSetting-colLf">
                                    <div className="chatSettingSelect">
                                        <TextField
                                            className="form-control--wrap form-control--hg32"
                                            select
                                            value={
                                                Utils.isEmptyObject(
                                                    props.userDelegateCreateTicketDetail
                                                )
                                                    ? ''
                                                    : props.userDelegateCreateTicketDetail.id
                                            }
                                            variant="outlined"
                                            onChange={onChangeSelectedGuestUser}
                                            disabled={isDisableUserListDelegateMsg}
                                            SelectProps={{
                                                MenuProps: {
                                                    anchorOrigin: {
                                                        vertical: 'bottom',
                                                        horizontal: 'left'
                                                    },
                                                    getContentAnchorEl: null,
                                                    className: 'selectDrop'
                                                }
                                            }}
                                        >
                                            {props.userGuestList.map(item => (
                                                <MenuItem key={item.id} value={item.id}>
                                                    {item.mail}
                                                </MenuItem>
                                            ))}
                                        </TextField>
                                        <div className="chatSettingThumb">
                                            <img
                                                src={
                                                    props.userDelegateCreateTicketDetail &&
                                                    props.userDelegateCreateTicketDetail.avatar
                                                        ? props.userDelegateCreateTicketDetail
                                                              .avatar
                                                        : Constant.AVATAR_DEFAULT
                                                }
                                                alt=""
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="chatSetting-colRg">
                                    <div className="chatSetting-group">
                                        <div className="formInput formInput-datePic">
                                            <DateTimePickerInput
                                                value={getDateTimeValue()}
                                                onChange={handlePostCreatedAtDateTimeOnChange}
                                                disabled={isPostCreatedAtCurrentTime}
                                                messageError={messageError}
                                                onClose={handleCloseDatePicker}
                                                showCloseButton={!isPostCreatedAtCurrentTime}
                                                format="YYYY/MM/DD HH:mm"
                                                placeholder=""
                                                heightClass="form-control-hg32"
                                                inputRef={dateTimePickerInputRef}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

            <DialogConfirmCreateTicketError
                isOpen={isOpenPopupTicketMsg}
                setIsOpen={setIsOpenPopupTicketMsg}
                onSubmit={handleReload}
                msgConfirm={trI18n('COMMSG002')}
            />

            <ConfirmDialog
                isOpen={createMsgErr.isShow}
                msgConfirm={createMsgErr.msg ? createMsgErr.msg : trI18n('COMMSG030')}
                okCallBack={() => window.location.reload()}
            />

            <Dialog
                open={!!openPreviewImage}
                onClose={() => setOpenPreviewImage(null)}
                maxWidth="md"
            >
                <img
                    alt=""
                    src={openPreviewImage}
                    style={{
                        maxWidth: '90vw',
                        maxHeight: '90vh',
                        objectFit: 'contain'
                    }}
                />
            </Dialog>
        </>
    );
};

export default ChatInput;

ChatInput.propTypes = {
    uploadFiles: PropTypes.any,
    setUploadFiles: PropTypes.any,
    setUploadedFiles: PropTypes.any,
    corporationDetail: PropTypes.any,
    projectInuseDetail: PropTypes.any,
    ticketInfo: PropTypes.any,
    panelType: PropTypes.any,
    userDelegateCreateTicketDetail: PropTypes.any,
    userGuestList: PropTypes.any,
};
